import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { environment } from '../../environments/environment';

/**
 * UrlSerializer personalizado que elimina la barra final de las URLs
 * para que Angular pueda hacer match con las rutas definidas sin barra,
 * mientras el navegador muestra URLs con barra final (manejado por el servidor).
 */
export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
    override parse(url: string): UrlTree {
        if (!environment.trailingSlash) {
            return super.parse(url);
        }
        const [rawPath, rawSuffix = ''] = url.split(/(?=[?#])/);
        const path =
            rawPath.length > 1 && rawPath.endsWith('/')
                ? rawPath.slice(0, -1)
                : rawPath;

        return super.parse(path + rawSuffix);
    }

    override serialize(tree: UrlTree): string {
        const serialized = super.serialize(tree);
        if (!environment.trailingSlash) {
            return serialized;
        }

        const [rawPath, rawSuffix = ''] = serialized.split(/(?=[?#])/);
        const path =
            rawPath.length > 1 && !rawPath.endsWith('/')
                ? rawPath + '/'
                : rawPath;

        return path + rawSuffix;
    }
}
